import React from "react";
import { Popup } from "@progress/kendo-react-popup";
import styles from "./HeaderProfile.module.scss";
import { List } from "./ProfileBox";
import profileIcon from "../../assets/Menu/profile.png";
import helpIcon from "../../assets/Menu/help.png";
import logoutIcon from "../../assets/Menu/logout.png";
import { useNavigate, useLocation } from "react-router-dom";
import { useOidc } from "@axa-fr/react-oidc";
import { Loader } from "@progress/kendo-react-indicators";
import { BiCog } from "react-icons/bi";
import { useAppViewMode } from "hooks/useAppViewMode";
import { VIEW_MODES } from "CONSTANT/ViewModes/AppViewModes";
import { useCurrentUser } from "services/currentUserService";
import { useCompany } from "services/companyService";
import { getAppConfig } from "../../services/configService";

export const ProfileDropdown = ({
  show,
  anchorEl,
  onClose,
  settingsEnabled = true,
}) => {
  const { data: company } = useCompany();
  const { data: userdata } = useCurrentUser();
  const navigate = useNavigate();
  const location = useLocation();
  const { appViewMode } = useAppViewMode();
  const fromPath = location.pathname.startsWith("/settings") ? (location.state?.from ?? "/") : location.pathname || "/";
  const { logout } = useOidc();

  const logoutApp = () => {
    const { authServerUrl } = getAppConfig();
    localStorage.removeItem(`oidc.server:${authServerUrl}/`);
    navigate("/");
    sessionStorage.clear();
    logout("/");
    onClose();
  };

  return (
    <div className={styles["popup-conatiner"]}>
      <Popup
        show={show}
        popupClass={styles["popup-content"]}
        animate={false}
        anchor={anchorEl}
      >
        <div className="popup-items mb-3">
          <p className={styles["company-name"]}>{company.displayNam}</p>
          <div className={styles["border-bottom"]}></div>
          {userdata.displayname === "User" ? (
            <div className="m-auto mt-2">
              <Loader />
            </div>
          ) : (
            <>
              <div className="d-flex pt-4 mx-auto">
                {/* <Avatar type="image" className={styles["profile-image"]}>
                    <img
                      className="h-100 w-100"
                      src={userdata.imageInfo.documentFile.downloadURL}
                      alt="P"
                    />
                  </Avatar> */}

                <div className="d-flex flex-column">
                  <span className={styles["profile-name"]}>
                    {userdata.displayname}
                  </span>
                  <span className={styles["profile-email"]}>
                    {userdata.emailAddress}
                  </span>
                  <span className={styles["job-title"]}>
                    {userdata.jobTitle || "Senior Solicitor"}
                  </span>
                </div>
              </div>
              <div className="flex flex-column  mt-4">
                <List
                  imageSrc={profileIcon}
                  name="Profile"
                  border={true}
                  onClick={() => {
                    const targetPath =
                      appViewMode === VIEW_MODES.OUTLOOK
                        ? `/settings/profile?viewmode=${VIEW_MODES.OUTLOOK}`
                        : `/settings/profile`;
                    navigate(targetPath, { state: { from: fromPath } });
                    onClose();
                  }}
                />
                {settingsEnabled && (
                  <List
                    border={true}
                    icon={<BiCog size={18} color="gray" />}
                    name="Settings"
                    onClick={() => {
                      navigate("/settings", { state: { from: fromPath } });
                      onClose();
                    }}
                  />
                )}
                <List border={true} imageSrc={helpIcon} name="Help & Guide" />
                <List
                  border={false}
                  imageSrc={logoutIcon}
                  name="Log Out"
                  onClick={logoutApp}
                />
              </div>
            </>
          )}
        </div>
      </Popup>
    </div>
  );
};
